import React from 'react';
import { getPositionStyle } from 'v2/views/components/charts/tooltip/utils/getPositionStyle';
import { OnHoverHandler } from 'v2/views/components/charts/types';
import { TriggerType } from './common';

const TooltipWrapper = ({
  onHoverHandle,
  styles,
  children,
  isDeltaTooltip,
}: {
  onHoverHandle: OnHoverHandler;
  styles: {
    clientX: number;
    clientY: number;
  };
  children: React.ReactNode;
  isDeltaTooltip?: boolean;
}) => {
  return (
    <div
      style={{
        zIndex: 9999999,
        position: 'fixed',
        width: isDeltaTooltip ? '312px' : '274px',
        ...getPositionStyle(
          styles && styles?.clientX,
          styles && styles?.clientY,
          isDeltaTooltip,
        ),
      }}
      onMouseEnter={(event) => {
        onHoverHandle(
          {},
          undefined,
          true,
          event,
          TriggerType.TOOLTIP_HOVER_TYPE,
        );
      }}
      onMouseLeave={(event) => {
        onHoverHandle(
          {},
          undefined,
          false,
          event,
          TriggerType.TOOLTIP_HOVER_TYPE,
        );
      }}
    >
      {children}
    </div>
  );
};

export default TooltipWrapper;
